'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'hand-point-ribbon';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e1a6';
var svgPathData = 'M375.1 192c-6.428 0-12.66 .8457-18.6 2.434C344.7 173.8 321.9 160 295.1 160c-6.428 0-12.66 .8457-18.6 2.434C264.7 141.8 241.9 128 215.1 128c-2.705 0-5.373 .1484-8 .4414V72c0-39.7-32.3-72-72-72s-72 32.3-72 72V96h-48C9.523 96 3.68 99.89 1.211 105.9S.1172 118.7 4.68 123.3L25.37 144L4.68 164.7C.1172 169.3-1.258 176.1 1.211 182.1S9.523 192 15.99 192h48v76.31C44.51 284.5 31.1 308.8 31.1 336l-.0059 49.88c0 32.1 17.1 61.65 44.63 77.12l55.83 31.35C153.1 505.9 176.4 512 199.8 512h107.9c77.37 0 140.3-64.6 140.3-144V264C447.1 224.3 415.7 192 375.1 192zM271.1 232c0-13.23 10.78-24 24-24s24 10.77 24 24l.0039 47.91C319.1 293.1 309.2 304 295.1 304s-24-10.77-24-24V232zM191.1 200c0-13.23 10.78-24 24-24s24 10.77 24 24v48c0 3.029-.7012 5.875-1.73 8.545C227.9 251.3 216.4 248 203.1 248h-12V200zM111.1 72c0-13.23 10.78-24 24-24s24 10.77 24 24V96h-48V72zM111.1 192h48v56h-40c-2.686 0-5.217 .5566-7.84 .793C112.1 248.5 111.1 248.3 111.1 248V192zM307.7 464H199.8c-15.25 0-30.41-3.984-43.88-11.52l-55.78-31.34c-12.44-6.984-20.16-20.5-20.16-35.27V336c0-22.06 17.94-40 40-40h84c15.44 0 28 12.56 28 28S219.4 352 203.1 352h-52c-13.25 0-23.1 10.75-23.1 24s10.75 24 23.1 24h52c33.23 0 61.25-21.58 71.54-51.36C282 350.7 288.9 352 295.1 352c5.041 0 9.836-1.166 14.66-2.178C322 374.6 346.1 392 375.1 392c7.684 0 14.94-1.557 21.87-3.836C388.9 431.4 351.9 464 307.7 464zM399.1 320c0 13.23-10.78 24-24 24s-24-10.77-24-24V264c0-13.23 10.78-24 24-24s24 10.77 24 24V320z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHandPointRibbon = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;